module.exports = __webpack_public_path__ + "img/mtbd_1.a3ca756a.png";